module.exports = __webpack_public_path__ + "static/media/undraw_proud_coder_7ain.49e1f687.svg";